import { Footer } from "../Footer/Footer"
import style from "./MobileBasketFooter.module.css"

export const MobileBasketFooter = () => {
	return <Footer className={style.mobileBasketFooter} />
}
